import React from "react";
import { Modal, Icon, Avatar, Dropdown, Button, Menu } from "antd";
import { withGlobal } from "../../../../component-global";
import { AuthService } from "../../../../services/AuthService.ts";
import {
  AgencyHeaderWrapper,
  LogoChazkiStrip,
  AgencyHeaderContent,
  CHAZKI_LOGO_WHITE,
} from "./style";

const authService = new AuthService();

class AgencyDashboardHeader extends React.Component {
  logout = () => {
    authService.logout();
  };

  confirmLogout = () => {
    Modal.confirm({
      title: "¿Esta seguro que desea cerrar sesion?",
      okText: "Si",
      cancelText: "No",
      onOk: this.logout,
    });
  };

  getDisplayName = () => {
    const { authUser } = this.props;
    const profile = authUser?.profile || {};
    const fullName = [profile.given_name, profile.family_name]
      .filter(Boolean)
      .join(" ");

    return fullName || profile.name || profile.email || "";
  };

  render() {
    const menu = (
      <Menu>
        <Menu.Item onClick={this.confirmLogout}>Cerrar Sesión</Menu.Item>
      </Menu>
    );

    return (
      <AgencyHeaderWrapper>
        <LogoChazkiStrip>
          <img alt="Chazki Logo" src={CHAZKI_LOGO_WHITE} />
        </LogoChazkiStrip>
        <AgencyHeaderContent>
          <div />
          <div>
            <Dropdown overlay={menu} placement="bottomCenter">
              <Button type="link">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Avatar
                    src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                    size={36}
                  />
                  <div className="namesUser">
                    {this.getDisplayName()}
                    <Icon
                      type="down"
                      style={{
                        color: "#307FE2",
                        marginLeft: "10px",
                        fontSize: 15,
                      }}
                    />
                  </div>
                </div>
              </Button>
            </Dropdown>
          </div>
        </AgencyHeaderContent>
      </AgencyHeaderWrapper>
    );
  }
}

export default withGlobal(AgencyDashboardHeader);
